import { render } from "./RelationEdit.vue?vue&type=template&id=3c55d910"
import script from "./RelationEdit.vue?vue&type=script&lang=js"
export * from "./RelationEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__